import { useQuery } from "@tanstack/react-query";

import { requestUnavailable } from "@softmax/observatory-client/transport";
import { CoworldReplayFrame } from "@softmax/web-features/replay";

import { replayFromEpisodeDetail } from "@/components/replay/episode-address";
import { episodeDetailQueryOptions } from "@/features/episodes/records";

export function ReplayEmbed({
  coworld,
  episodeId,
  title,
  chrome,
  viewerSize,
  poster,
}: {
  coworld: string;
  episodeId: string;
  title: string;
  chrome?: "controls" | "off" | null;
  viewerSize?: { width: number; height: number } | null;
  poster?: string | null | undefined;
}) {
  const episode = useQuery(episodeDetailQueryOptions(episodeId));

  if (!episode.data || requestUnavailable(episode.error)) {
    return (
      <div
        role={episode.isError ? "alert" : "status"}
        className="flex size-full flex-col items-center justify-center gap-2 bg-[#f8f3e8] font-plex-mono text-[11px] text-[rgba(22,22,22,0.62)]"
      >
        <span>
          {episode.isError ? "Replay could not be loaded" : "Loading replay…"}
        </span>
        {episode.isError ? (
          <button type="button" onClick={() => void episode.refetch()}>
            Try again
          </button>
        ) : null}
      </div>
    );
  }

  const pick = replayFromEpisodeDetail(episode.data);

  if (!pick) {
    return (
      <div className="flex size-full items-center justify-center bg-[#f8f3e8] font-plex-mono text-[11px] text-[rgba(22,22,22,0.62)]">
        Replay unavailable
      </div>
    );
  }

  return (
    <CoworldReplayFrame
      coworldId={pick.coworldId}
      replayUri={pick.replayUrl}
      telemetryContext={{
        game: pick.coworldName ?? coworld,
        gameVersion: pick.coworldVersion,
        episodeId: pick.episodeId,
      }}
      surface="episode_detail"
      title={title}
      bare
      chrome={chrome ?? undefined}
      viewerSize={viewerSize ?? undefined}
      poster={poster ?? undefined}
      height="100%"
      minHeight="0"
      diagnostics={false}
    />
  );
}
